module.exports = new __parcel__URL__("soleil-nuage-1-pluie-2.31358178.svg").toString();